import { styled } from '@mui/material/styles';
import { GridRowProps as MuiGridRowProps, GridRow as MuiGridRow } from '@mui/x-data-grid-pro';
import { StickyBorderBox } from '../Common/StickyBorderBox';
import React from 'react';
import { getFontScale } from 'src/common/utils/fonts';

export const RowRoot = styled('div')({
  position: 'relative',
});

const BorderContainer = styled('div')({
  position: 'absolute',
  left: 0,
  right: 0,
  zIndex: 99999,
  pointerEvents: 'none',
});

export const GridRow = React.memo((props: MuiGridRowProps) => {
  return (
    <RowRoot>
      <BorderContainer>
        <StickyBorderBox height={52 * getFontScale()} />
      </BorderContainer>
      <MuiGridRow {...props} />
    </RowRoot>
  );
});
